export default __webpack_public_path__ + "static/media/cover3.aa91e346.jpg";